var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightarrow1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 80C63.0914 80 81 62.0914 81 40C81 17.9086 63.0914 0 41 0C18.9086 0 1 17.9086 1 40C1 62.0914 18.9086 80 41 80Z",
    fill: "#2D3B36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 39.0002H1L1 41.0002H2V39.0002ZM42.7071 40.7073C43.0976 40.3168 43.0976 39.6836 42.7071 39.2931L36.3431 32.9291C35.9526 32.5386 35.3195 32.5386 34.9289 32.9291C34.5384 33.3197 34.5384 33.9528 34.9289 34.3433L40.5858 40.0002L34.9289 45.6571C34.5384 46.0476 34.5384 46.6807 34.9289 47.0713C35.3195 47.4618 35.9526 47.4618 36.3431 47.0713L42.7071 40.7073ZM2 40.0002V41.0002H42V40.0002V39.0002H2V40.0002Z",
    fill: "#FEFFF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow1);
export default __webpack_public_path__ + "static/media/right arrow 1.fcf7dba67f1245f3de2752c834beb6bc.svg";
export { ForwardRef as ReactComponent };